import apiClient from "../api/apiClient"
import { StiRatesResponse } from "../../types"

export interface UpdateStiRateEntry {
  sku_id: string
  rate: number
}

export const stiRatesService = {
  async getStiRates(customerId: string): Promise<StiRatesResponse> {
    const response = await apiClient.get<StiRatesResponse>(`/admin/sti-rates/${customerId}`)
    return response.data
  },

  async updateStiRates(
    customerId: string,
    rates: UpdateStiRateEntry[]
  ): Promise<{ message: string; customer_name: string; rates: UpdateStiRateEntry[] }> {
    const response = await apiClient.put(`/admin/sti-rates/${customerId}`, { rates })
    return response.data
  },
}
